import hexToRGB from './hexToRGB';

export default function textColorForBackground(backgroundColor) {
  const rgb = hexToRGB(backgroundColor);
  if (rgb[0] + rgb[1] + rgb[2] > 400) {
    return '#000';
  }
  return '#fff';
}
